export default "__VITE_ASSET__CA5elFZ7__"